import React from "react";
import { useFormContext, UseFormReturn, FieldValues, FieldErrors, Control } from "react-hook-form";
export type FormProps = UseFormReturn & {
  errors: FieldErrors<FieldValues>;
  control: Control;
  clearErrors(name?: string): void;
};
const ConnectForm = ({
  children
}: {
  children: (props: FormProps) => React.ReactElement;
}) => {
  const methods = useFormContext();
  const {
    errors
  } = methods.formState;
  return children({
    ...methods,
    errors
  });
};
export default ConnectForm;